import { render, staticRenderFns } from "./OriginalLanguageViewer.vue?vue&type=template&id=2668bef4&scoped=true&"
import script from "./OriginalLanguageViewer.vue?vue&type=script&lang=js&"
export * from "./OriginalLanguageViewer.vue?vue&type=script&lang=js&"
import style0 from "./OriginalLanguageViewer.vue?vue&type=style&index=0&id=2668bef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668bef4",
  null
  
)

export default component.exports